import faker from 'faker'
import moment from 'moment'
import hres6meLabels from 'assets/labels/hres6me'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres6meLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtereq: moment().format('DD/MM/YYYY'),
        seqno: faker.random.number().toString().substr(0, 1),
        desc_codleave: faker.lorem.word(),
        dtestrt: moment().format('DD/MM/YYYY'),
        dteend: moment().format('DD/MM/YYYY'),
        timstrt: faker.date.past().toString().substr(16, 5),
        timend: faker.date.past().toString().substr(16, 5),
        numlereq: faker.random.number(),
        status: faker.lorem.word(),
        statuscc: faker.lorem.word(),
        remarkapcc: faker.lorem.words(),
        desc_codapprcc: faker.name.findName(),
        desc_codempapcc: faker.name.findName(),
        codleave: faker.lorem.word(),
        staappr: faker.lorem.word(),
        staapprcc: faker.lorem.word(),
        codapprcc: faker.lorem.word(),
        codempapcc: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let arrFlgleave = [ 'A', 'M', 'E', 'H' ]
    let mockDetail = {
      codleave: faker.lorem.word(),
      desc_codleave: faker.lorem.word(),
      flgleave: arrFlgleave[Math.floor(Math.random() * 5)],
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timstrt: faker.date.past().toString().substr(16, 5),
      timend: faker.date.past().toString().substr(16, 5),
      deslereq: faker.lorem.word(),
      desreq: faker.lorem.word()
    }

    return mockDetail
  },
  saveCancel () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6me/mocker.js